export default __webpack_public_path__ + "static/media/slider03.64bef10a.jpg";